import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from 'recharts';

interface AIUsageChartProps {
  userMetrics: {
    data: {
      usersPerDay: Array<{ date: string; count: number }>;
      aiUsagePerDay: Array<{ date: string; total: number }>;
    };
  } | undefined;
  aiUsage: {
    data: Array<{ feature: string; usageCount: number }>;
  } | undefined;
}

export function AIUsageChart({ userMetrics, aiUsage }: AIUsageChartProps) {
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>AI Usage</CardTitle>
          <CardDescription>AI feature usage over time</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={userMetrics?.data.aiUsagePerDay || []}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tickFormatter={(date) => new Date(date).toLocaleDateString()} />
                <YAxis />
                <Tooltip
                  labelFormatter={(date) => new Date(date).toLocaleDateString()}
                  formatter={(value: number) => [value, 'Usage Count']}
                />
                <Line type="monotone" dataKey="total" stroke="#8b5cf6" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>AI Feature Usage</CardTitle>
          <CardDescription>Usage by feature type</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={aiUsage?.data.slice(0, 10) || []}
                layout="vertical"
                margin={{ left: 100 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis dataKey="feature" type="category" width={90} tick={{ fontSize: 12 }} />
                <Tooltip formatter={(value: number) => [value, 'Usage Count']} />
                <Bar dataKey="usageCount" fill="#22c55e" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
